export default "__VITE_ASSET__DTg2OIrA__"